export default __webpack_public_path__ + "static/media/lobbey2.1d657d92.jpg";